import ListView from "@/common/custom-lists/ListView";
import { orderBy, update } from "lodash";
import { connect } from "react-redux";
import ReportClientsRow from "./ReportClientsRow";
import { Actions as REPORTACTIONS } from "../../../store/actions/reportActions";
import { useNavigate, useParams } from "react-router-dom";
import { DocumentTextIcon } from "@heroicons/react/20/solid";

const ReportPackClients = ({ organisations, reportPacks, saveReportPacks }) => {
	const { id } = useParams();
	const columns = [{ hidden: true }, "Company", "Apply Report Pack", { hidden: true }];
	const navigate = useNavigate();

	return (
		<>
			<div className="col-xs-12 p-0 mt-5">
				<div
					className="btn btn-success"
					onClick={() => navigate("/advisor/reports/clients")}
				>
					<DocumentTextIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
					<span style={{ float: "left" }}>Apply Multiple Report Packs</span>
				</div>
			</div>
			<div className="mt-20">
				<ListView
					{...{
						title: "Client",
						items: organisations?.map((organisation) => {
							const updateApplied = (applied) => {
								const newReportPacks = [...reportPacks];

								const reportIndex = newReportPacks?.findIndex((pack) => pack.id === id);
								const newReportPack = newReportPacks[reportIndex];

								if (!newReportPack || reportIndex == -1) return;

								if (applied) {
									newReportPack["appliedOrgs"].push(organisation.id);
								} else {
									newReportPack["appliedOrgs"] = newReportPack["appliedOrgs"].filter(
										(orgId) => orgId !== organisation.id,
									);
								}

								newReportPacks[reportIndex] = newReportPack;

								saveReportPacks(newReportPacks);
							};

							const applied = reportPacks
								?.find((pack) => pack.id === id)
								?.appliedOrgs?.includes(organisation.id);

							return (
								<ReportClientsRow
									organisation={organisation}
									updateApplied={updateApplied}
									isApplied={applied && true}
								/>
							);
						}),
						columns,
					}}
				/>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	const advisorCompanies = state?.organisations?.filter((c) => c.isAdvisor);

	return {
		organisations: orderBy(advisorCompanies, ["name"], ["asc"]),
		reportPacks: state.advisors?.reports?.reportPacks || [],
	};
};

const mapDispatchToProps = (dispatch) => ({
	saveReportPacks: (reportPacks) => dispatch(REPORTACTIONS.postReportPacks(reportPacks)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportPackClients);
